import { connect } from 'react-redux';
import Header from '../../components/header';
import { toggleMobileNav, toggleSearch } from '../../actions';

const mapStateToProps = state => ({
    mobileNavActive: state.ui.navActive,
    mobileSearchActive: state.ui.searchActive
});

export default connect(mapStateToProps, { toggleMobileNav, toggleSearch })(
    Header
);



// WEBPACK FOOTER //
// ./src/containers/header/index.js